"use strict";

import './../sass/category.sass';

import { addMultipleListeners, ajaxGet } from "./helpers.js";

document.addEventListener('DOMContentLoaded', function() {

	/* aktualizace zájezdů */
	const tours = document.getElementById('fn_tours');

	if (tours !== null) {

		const today      = tours.getAttribute('data-date'),
			lastUpdate = tours.getAttribute('data-last-update'),
			idCountry  = tours.getAttribute('data-page');

		if (today > lastUpdate) {

			ajaxGet('/ajax.php?refreshTours=1&id_country=' + idCountry, function (responseData) {
				if (responseData.result == 1) {
					console.log('%c ' + responseData.message, 'color: #598527');
				} else {
					throw (responseData.message);
				}
			}, function (error) {
				console.error(error);
			});

		}

	}

	/* ajax - další zájezdy */
	initNextTours();

});

function initNextTours() {
	const nextToursBtns = document.querySelectorAll('.fn_tour-next');

	nextToursBtns.forEach((btn) => {
		nextTours(btn);
	});
}

function nextTours(element) {

	addMultipleListeners(element, ['click', 'touch'], function () {

		const data = {
			id_hotel: this.getAttribute('data-hotel-tours'),
			count_tours: this.getAttribute('data-count-tours'),
			next_tours: this.getAttribute('data-next-tours'),
			next_tours_add: parseInt(this.getAttribute('data-next-tours')) + 10,
			last_minute: this.getAttribute('data-lm'),
			region: this.getAttribute('data-region'),
			date_from: this.getAttribute('data-date_from') ? this.getAttribute('data-date_from') : 'undefined',
			date_to: this.getAttribute('data-date_to') ? this.getAttribute('data-date_to') : 'undefined',
			days: this.getAttribute('data-days') ? this.getAttribute('data-days') : 'undefined',
			toursCover: this.parentNode
		};

		/* before send */
		data.toursCover.removeChild(data.toursCover.querySelector('.fn_tour-next'));
		data.toursCover.innerHTML += '<div class="p_spinner"><span class="p_spinner__in"></span>Nahrávám...</div>';

		ajaxGet('ajax.php?next=1&id_hotel=' + data.id_hotel + '&next_tours=' + data.next_tours + '&last-minute=' + data.last_minute + '&region=' + data.region + '&date_from=' + data.date_from + '&date_to=' + data.date_to + '&days=' + data.days, function (responseData) {
			if (responseData) {
				data.toursCover.querySelector('.p_spinner').parentNode.removeChild(data.toursCover.querySelector('.p_spinner'));
				data.toursCover.innerHTML += request.responseText;

				if (data.count_tours > parseInt(data.next_tours_add + 10)) {
					data.toursCover.querySelector('.c_tour__item:last-child').insertAdjacentHTML('afterend', '<a href="javascript:void(0);" data-hotel-tours="' + data.id_hotel + '" data-count-tours="' + data.count_tours + '" data-next-tours="' + data.next_tours_add + '" data-lm="' + data.last_minute + '"  data-date_from="' + data.date_from + '" data-date_to="' + data.date_to + '" data-days="' + data.days + '" class="fn_tour-next c_tour__next"><span>Další termíny</span></a>');

					// reinit
					nextTours(data.toursCover.querySelector('.fn_tour-next'));

				} else {
					data.toursCover.parentNode.querySelector('.c_tour__next--link-none').style.display = 'block';
				}
			} else {
				throw ('It´s not possible to loading tours!');
			}
		}, function (error) {
			console.error('It´s not possible to loading tours:', error);
		});

	});

}